;(function ($, window) {
  'use strict'

  window.eah = window.eah || {}

  eah.checkbox = (function () {
    const initialize = function () {
      $('.js-checkbox').on('click', function (e) {
        $(this).parent().toggleClass('is-selected')
        // console.log('hey', this.checked);
        // $(this).prop('checked', this.checked);
        if ($(this).hasClass('broker')) {
          $('.brokerage-wrap').toggle()
        }

        if ($(this).hasClass('toggleMIRH')) {
          // Hide/reveal items that don't have lots.
          $('.card.no-lots').toggle()
          $('.search-result.no-lots .comm-no-results').toggle()
        }
      })
    }

    return {
      initialize: initialize
    }
  }())

  $(function () {
    eah.checkbox.initialize()
  })
}(jQuery, window))
